const payer = {
  id: 0,
  payer_group_id: '',
  status: '',
  cnpj: '',
  fantasy_name: '',
  legal_name: '',
  uf: '',
  city: '',
  cep: '',
  neighborhood: '',
  address: '',
  address_number: '',
  website: '',
  min_days: 15,
  max_days: 390,
  min_value: 5000,
  rebate: null,
  internal_tax: 1.90,
  internal_commission: 1.80,
  new_limit: 0,
  assignors_type: 'invoice',
  payer_contacts: [],
  payer_contacts_attributes: [],
  limits: [],
  last_limits: [],
  limits_attributes: [],
  import_template_ids: [],
  mail_templates: [],
  mail_template_welcome_id: null,
  mail_template_available_invoice_id: null,
  mail_template_partnership_id: null,
  rescue_availability_start_time: null,
  rescue_availability_end_time: null,
  fund_id: null,
  funds: [],
  payer_funds: [],
  payer_funds_attributes: [],
  branch_offices: [],
  branch_offices_attributes: []
}

const errors = {
  infos: [],
  contact: [],
  importRule: [],
  taxLimit: [],
  docs: [],
  funds: [],
  branch_offices: []
}

export default {
  initialPayer: { ...payer },
  payer: { ...payer },
  initialErrors: { ...errors },
  errors: { ...errors },
  list: [],
  current: {
    limit_total: 0,
    limit_used: 0
  },
  listToCampaign: []
}



// WEBPACK FOOTER //
// ./src/features/payers/store/state.js